var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100%","height":"100%","position":"relative"}},[_c('div',{style:({width:'100%', height:_vm.height}),attrs:{"id":_vm.id}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNull),expression:"isNull"}],staticClass:"nostr",style:({width:_vm.width, height:_vm.height})},[_vm._v("No Data")])])
}
var staticRenderFns = []

export { render, staticRenderFns }